import { Pipe, PipeTransform } from '@angular/core';
import { EmptyPipe } from './empty.pipe';

@Pipe({
  name: 'numberToCurrency',
  standalone: true
})
export class NumberToCurrencyPipe implements PipeTransform {

  public transform(val: number): string {
    return !isNaN(val) ? val.toCurrency() : new EmptyPipe().transform(null) as string;
  }
}
